import { safeAbsurd } from '@ipfabric/utils/types';
import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import type { InteractiveAtomSize } from '../utils/InteractiveAtomProps';

export type FormFieldHelperTextSize = InteractiveAtomSize;

export type FormFieldHelperTextProps = {
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  size?: FormFieldHelperTextSize;
  variant?: 'default' | 'plain';
};

const sizeClassName: { [Key in FormFieldHelperTextSize]: string } = {
  small: 'text-xs',
  default: 'text-xs',
  large: 'text-sm',
};

const getVariantClassName = (
  variant: 'default' | 'plain',
  disabled?: boolean,
) => {
  switch (variant) {
    case 'default':
      return disabled ? 'text-status-disabled-dark' : 'text-default';
    case 'plain':
      return 'text-plain';
    default:
      safeAbsurd(
        variant,
        `Unsupported variant ${variant} in FormFieldHelperText`,
      );
      return '';
  }
};

export const FormFieldHelperText: FC<FormFieldHelperTextProps> = ({
  children,
  className,
  disabled,
  size = 'default',
  variant = 'default',
}) => (
  <output
    className={classNames(
      getVariantClassName(variant, disabled),
      sizeClassName[size],
      className,
    )}
  >
    {children}
  </output>
);
